module.exports = {"150621001":"工业街道","150621002":"昭君街道","150621003":"锡尼街道","150621004":"白塔街道","150621005":"西园街道","150621006":"平原街道","150621100":"树林召镇","150621101":"吉格斯太镇","150621102":"白泥井镇","150621103":"王爱召镇","150621104":"昭君镇","150621105":"恩格贝镇","150621106":"中和西镇","150621107":"风水梁镇","150621200":"展旦召苏木","150621400":"达拉特经济开发区","150621401":"鄂尔多斯市生态示范区管理委员会"}


//////////////////
// WEBPACK FOOTER
// ./src/town/150621.json
// module id = 526
// module chunks = 0